export default __webpack_public_path__ + "static/media/send-campaign.2e5472c1.png";